import type { CustomerDto } from "../../services/CustomerService";
import { type Customer, type DateFormat, PRODUCT_FEATURES, type ProductFeature } from "../../state/customer";
import CustomerId from "../../state/CustomerId";
import CustomerUid from "../../state/CustomerUid";
import { extractDateFromObjectId } from "../objectIdUtil";
import { isNil } from "lodash-es";
import { isValidDate, parseDateOnly } from "../dateUtil";

const toDeleteOn = (deleteOn: string | undefined): Date | undefined => {
  if (isNil(deleteOn)) {
    return undefined;
  }

  const parsed = parseDateOnly(deleteOn);
  return isValidDate(parsed) ? parsed : undefined;
};

export const toCustomer = (dto: CustomerDto): Customer => ({
  id: CustomerUid.from(dto.id),
  customerId: CustomerId.from(dto.customerId.toString()),
  name: dto.name,
  unlockedFeatures: dto.unlockedFeatures.filter((feature): feature is ProductFeature =>
    PRODUCT_FEATURES.includes(feature),
  ),
  createdOn: extractDateFromObjectId(dto.id),
  logoAssetId: dto.logoAssetId ?? undefined,
  settings: {
    dateFormat: dto.settings.dateFormat as DateFormat,
    segment: dto.settings.segment,
    otherSegment: dto.settings.otherSegment,
  },
  meta: {
    deleteOn: toDeleteOn(dto.meta.deleteOn),
  },
});
